module.exports = __webpack_public_path__ + "img/vlogo-purple.8fc55459.png";